import { entries } from '@/mocks/home';

export default function SiteFooter() {
  const quick = entries.slice(0, 4);

  return (
    <footer className="bg-accent-950 text-background-100">
      <div className="mx-auto max-w-shell px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50">
                <span className="font-label text-lg leading-none text-accent-700">51</span>
              </span>
              <span className="font-label text-xl tracking-wide text-background-50">51黑料</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              整理 51黑料官网最新地址与备用域名，帮助你在网址打不开时快速找到可访问的入口。本页仅作地址与线路信息索引，持续更新。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full border border-background-50/20 px-3 py-1.5 text-[13px] text-background-100">最新地址</span>
              <span className="rounded-full border border-background-50/20 px-3 py-1.5 text-[13px] text-background-100">备用域名</span>
              <span className="rounded-full border border-background-50/20 px-3 py-1.5 text-[13px] text-background-100">入口合集</span>
            </div>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-label text-base tracking-wider text-background-50">常用入口</h3>
            <ul className="mt-4 space-y-3">
              {quick.map((e) => (
                <li key={e.id} className="flex items-center justify-between gap-3 text-sm">
                  <a
                    href="#entry"
                    className="flex items-center gap-2 text-background-200 transition-colors hover:text-primary-300"
                  >
                    <i className="ri-links-line text-primary-400" />
                    {e.type}入口
                  </a>
                  <span className="flex items-center gap-1.5 text-[12px] text-background-300">
                    <span className={`h-1.5 w-1.5 rounded-full ${e.status === '可用' ? 'bg-primary-400' : 'bg-secondary-400'}`} />
                    {e.status}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-label text-base tracking-wider text-background-50">页面导航</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a href="#entry" className="text-background-200 transition-colors hover:text-primary-300">入口合集</a>
              </li>
              <li>
                <a href="#updates" className="text-background-200 transition-colors hover:text-primary-300">更新短讯</a>
              </li>
              <li>
                <a href="#topics" className="text-background-200 transition-colors hover:text-primary-300">话题墙</a>
              </li>
              <li>
                <a href="#fix" className="text-background-200 transition-colors hover:text-primary-300">打不开怎么找</a>
              </li>
              <li>
                <a href="#faq" className="text-background-200 transition-colors hover:text-primary-300">常见问题</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center">
          <p className="text-[13px] text-background-300">© 2026 51黑料地址索引 · 仅供访问参考</p>
          <p className="text-[13px] text-background-300">持续更新 · 建议收藏本页以便核对最新入口</p>
        </div>
      </div>
    </footer>
  );
}